import React from 'react';
import './full-page-dialog.scss';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import Typography from '@material-ui/core/Typography';
import GetExpenseForm from '../GetExpenseForm';

const Transition = React.forwardRef((props, ref) => <Slide direction="right" ref={ref} {...props} />);


const GetExpenseDialog = ({ open, handleClose }) => (
  <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition} classes={{ paperFullScreen: 'dialog-bg' }}>
    <AppBar className="appBar" color="inherit" style={{ position: 'relative' }}>
      <Toolbar variant="dense" disableGutters elevation={0}>
        <IconButton edge="start" onClick={handleClose} aria-label="close">
          <FontAwesomeIcon style={{ fontSize: 16 }} icon={faChevronLeft} />
        </IconButton>
        <Typography variant="h6" className="toolbar-title title-type">
              Cobrar Gasto
        </Typography>
      </Toolbar>
    </AppBar>
    <GetExpenseForm />
  </Dialog>

);

export default GetExpenseDialog;
